module.exports = __webpack_public_path__ + "img/rec-serial-3.fceecc8.png";